import { exhaustMap, interval, isObservable, last, lastValueFrom, Observable, share, startWith, takeWhile } from 'rxjs';
import { IsCompleted, PollFunction, TaskParams } from './';

export abstract class AbstractTask implements TaskParams {
    readonly pollFunction: PollFunction;
    readonly isCompleted: IsCompleted;
    readonly tolerateError: boolean;
    protected poolCount = 0;
    protected cancelled = false;

    private poolInProgress = false;

    constructor(params: TaskParams) {
        Object.assign(this, params);
    }

    public cancel() {
        this.cancelled = true;
    }

    public isCancelled() {
        return this.cancelled;
    }

    protected async poll() {
        if (this.poolInProgress) {
            return null;
        }
        this.poolCount++;
        this.poolInProgress = true;
        let pollResponse;
        try {
            let asyncResponse = this.pollFunction();
            let promise = isObservable(asyncResponse) ? lastValueFrom(asyncResponse) : asyncResponse;
            pollResponse = await promise;
        } catch (e) {
            pollResponse = null;
            if (!this.tolerateError) {
                throw e;
            }
        }
        this.poolInProgress = false;
        return pollResponse;
    }

	public abstract startPolling(poolingInterval: number, maxRetry: number, startAfterInterval?: boolean): Promise<any>;
}
